/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { Col, Row, message, Typography, Table, Modal } from "antd";
import { AntdButton, InputField, SelectInput, SwitchField } from "../../../blueplanitUtils/InputField";
import { useSelector, useDispatch } from "react-redux";
import { getOptionsByPath } from "../../../utilsdata.js";
import { getleavesThunk, updateleavesThunk, updateleavesettingThunk } from "../../../Slices/LeavesSlice";
import { ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT, LEAVE_SETTINGS, LEAVEETTINGS_YEAR } from "../../../Dropdownmanager.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

const { Title } = Typography;

const QuarterlyBreakdownTable = ({ record }) => {
  const casualLeaves = Number(record.casualLeaves || 0);
  const medicalLeave = Number(record.medicalLeave || 0);

  const clPerQuarter = 2;
  const elPerQuarter = casualLeaves === 16 ? 2 : 1;
  const totalAnnual = clPerQuarter * 4 + elPerQuarter * 4 + medicalLeave;

  // Build rows manually to control per-cell rendering
  const rows = [
    {
      key: "cl",
      type: "Casual Leave (CL)",
      q1: clPerQuarter,
      q2: clPerQuarter,
      q3: clPerQuarter,
      q4: clPerQuarter,
      total: clPerQuarter * 4,
      bold: false,
    },
    {
      key: "el",
      type: "Earned Leave (EL)",
      q1: elPerQuarter,
      q2: elPerQuarter,
      q3: elPerQuarter,
      q4: elPerQuarter,
      total: elPerQuarter * 4,
      bold: false,
    },
    {
      key: "sl",
      type: "Sick Leave (SL)",
      q1: "",      // empty
      q2: medicalLeave, // only Q2 shows value (like image)
      q3: "",      // empty
      q4: "",      // empty
      total: medicalLeave,
      bold: false,
      isSL: true,
    },
    {
      key: "total",
      type: "Total",
      q1: "",   // all Q columns empty for total row
      q2: "",
      q3: "",
      q4: "",
      total: totalAnnual,
      bold: true,
    },
  ];

  const columns = [
    {
      title: "Type of Leave",
      dataIndex: "type",
      key: "type",
      render: (text, row) => (
        <span style={{ fontWeight: row.bold ? 700 : 600 }}>{text}</span>
      ),
    },
    {
      title: "Q1",
      dataIndex: "q1",
      key: "q1",
      align: "center",
      render: (val, row) => (
        <span style={{ fontWeight: row.bold ? 700 : 400 }}>{val}</span>
      ),
    },
    {
      title: "Q2",
      dataIndex: "q2",
      key: "q2",
      align: "center",
      render: (val, row) => (
        <span style={{ fontWeight: row.bold ? 700 : 400 }}>{val}</span>
      ),
    },
    {
      title: "Q3",
      dataIndex: "q3",
      key: "q3",
      align: "center",
      render: (val, row) => (
        <span style={{ fontWeight: row.bold ? 700 : 400 }}>{val}</span>
      ),
    },
    {
      title: "Q4",
      dataIndex: "q4",
      key: "q4",
      align: "center",
      render: (val, row) => (
        <span style={{ fontWeight: row.bold ? 700 : 400 }}>{val}</span>
      ),
    },
    {
      title: "Total (Annual)",
      dataIndex: "total",
      key: "total",
      align: "center",
      render: (val, row) => (
        <span style={{ fontWeight: 700 }}>{val}</span>
      ),
    },
  ];

  return (
    <div style={{ padding: "16px 24px 20px", background: "#fff", borderTop: "1px solid #f0f0f0" }}>
      {/* Header */}
      <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontWeight: 600, fontSize: 14, color: "#222" }}>
          Annual Leave Entitlement
        </span>
        <span style={{
          fontSize: 12, padding: "2px 10px", borderRadius: 12,
          border: "1px solid #d9d9d9", color: "#555", background: "#fafafa",
        }}>
          {casualLeaves === 16 ? "6-Day Work Week" : "5-Day Work Week"}
        </span>
      </div>

      <Table
        dataSource={rows}
        columns={columns}
        pagination={false}
        size="small"
        rowKey="key"
        bordered
        rowClassName={(row) => row.bold ? "leave-total-row" : ""}
        style={{ maxWidth: 680 }}
      />

      <style>{`
        .leave-total-row td {
          background: #fafafa !important;
          font-weight: 700 !important;
        }
      `}</style>
    </div>
  );
};

// ─────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────
const LeaveSettings = () => {
  const leavesData = useSelector((state) => state.leaves.leaves);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const [originalLeaveData, setOriginalLeaveData] = useState(null);

  const dispatch = useDispatch();
  const userId = loginUser?.id;

  const [leaveData, setLeaveData] = useState({
    casualLeaves: "",
    CarryforwardLeaves: "",
    medicalLeave: "",
    department: "",
    year: "",
    carryFlag: false,
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    dispatch(getleavesThunk());
  }, [dispatch]);

  const handleChange = (name, value) => {
    setLeaveData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    try {
      if (!leaveData.year || !leaveData.department || !leaveData.casualLeaves || !leaveData.medicalLeave) {
        message.error("Year, Department, Casual Leaves, and Medical Leaves are required.");
        return;
      }
      if (leaveData.carryFlag && !leaveData.CarryforwardLeaves) {
        message.error("Carry forward Leaves must be entered if Carry forward is Yes.");
        return;
      }
      if (isEdit && originalLeaveData && isDataEqual(leaveData, originalLeaveData)) {
        message.info("No changes detected.");
        setIsModalVisible(false);
        return;
      }
      const duplicate = leavesData.find((item) => {
        if (isEdit) {
          return item.year === leaveData.year && item.department === leaveData.department && item._id !== leaveData._id;
        } else {
          return item.year === leaveData.year && item.department === leaveData.department;
        }
      });
      if (duplicate) {
        message.warning(`Leave record already exists for ${leaveData.department} (${leaveData.year}).`);
        setLeaveData((prev) => ({ ...prev, department: "", year: "" }));
        return;
      }
      const { __typename, ...cleanLeaveData } = leaveData;
      await dispatch(updateleavesThunk({ input: cleanLeaveData }));
      await dispatch(updateleavesettingThunk({ ...cleanLeaveData, EmpID: userId, Key: false }));
      await dispatch(getleavesThunk());
      message.success("Employee Leaves updated successfully", 3);
      setIsModalVisible(false);
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  const handleOpenModal = () => {
    setLeaveData({ casualLeaves: "", CarryforwardLeaves: "", medicalLeave: "", department: "", year: "", carryFlag: false });
    setIsEdit(false);
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setLeaveData(record);
    setOriginalLeaveData(record);
    setIsEdit(true);
    setIsModalVisible(true);
  };

  const isDataEqual = (a, b) => Object.keys(a).every((key) => a[key] === b[key]);

  const leavesByYear = leavesData.reduce((acc, leave) => {
    if (!acc[leave.year]) acc[leave.year] = [];
    acc[leave.year].push(leave);
    return acc;
  }, {}) || {};

  const tableColumns = [
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      render: (text) => <span style={{ fontWeight: 600 }}>{text}</span>,
    },
    {
      title: "Casual Leaves",
      dataIndex: "casualLeaves",
      key: "casualLeaves",
      align: "center",
    },
    {
      title: "Medical Leaves",
      dataIndex: "medicalLeave",
      key: "medicalLeave",
      align: "center",
    },
    {
      title: "Carry Forward",
      key: "carryForward",
      align: "center",
      render: (_, record) =>
        record.carryFlag ? `Yes — ${record.CarryforwardLeaves} days` : "No",
    },
    {
      title: "Work Week",
      key: "workWeek",
      align: "center",
      render: (_, record) =>
        Number(record.casualLeaves) === 16 ? "6-Day" : "5-Day",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <FontAwesomeIcon
          icon={faPen}
          style={{ fontSize: 14, color: "#1890ff", cursor: "pointer" }}
          onClick={(e) => { e.stopPropagation(); handleEdit(record); }}
        />
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">

              <div style={{ marginBottom: 20, display: "flex", justifyContent: "flex-end" }}>
                <AntdButton label="Add Leave" type="primary" onClick={handleOpenModal} />
              </div>

              <Modal
                title={isEdit ? "Edit Leave Settings" : "Add Leave Settings"}
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                onOk={handleSubmit}
                okText={isEdit ? "Update" : "Add"}
                destroyOnClose
                width={500}
              >
                <form onSubmit={handleSubmit}>
                  <Row gutter={24}>
                    <Col span={12}>
                      <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                        Select Department:<span style={{ color: "red", marginLeft: 4 }}>*</span>
                      </label>
                      <SelectInput
                        value={leaveData.department}
                        style={{ width: 200 }}
                        onChange={(value) => handleChange("department", value)}
                        options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                        disabled={isEdit}
                      />
                    </Col>
                    <Col span={12}>
                      <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                        Select Year:<span style={{ color: "red", marginLeft: 4 }}>*</span>
                      </label>
                      <SelectInput
                        value={leaveData.year}
                        style={{ width: 200 }}
                        onChange={(value) => handleChange("year", value)}
                        options={getOptionsByPath(NestedDatabucket, [LEAVE_SETTINGS, LEAVEETTINGS_YEAR])?.filter(option => {
                          const currentYear = new Date().getFullYear();
                          return parseInt(option.value) >= currentYear;
                        })}
                        disabled={isEdit}
                      />
                    </Col>
                  </Row>

                  <Row gutter={24} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                        Casual Leaves:<span style={{ color: "red", marginLeft: 4 }}>*</span>
                      </label>
                      <InputField
                        value={leaveData.casualLeaves}
                        type="number"
                        name="casualLeaves"
                        onChange={(e) => handleChange("casualLeaves", e.target.value)}
                        className="form-control"
                      />
                    </Col>
                    <Col span={12}>
                      <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                        Medical Leaves:<span style={{ color: "red", marginLeft: 4 }}>*</span>
                      </label>
                      <InputField
                        value={leaveData.medicalLeave}
                        type="number"
                        name="medicalLeave"
                        onChange={(e) => handleChange("medicalLeave", e.target.value)}
                        className="form-control"
                      />
                    </Col>
                  </Row>

                  <div style={{ marginTop: 16 }}>
                    <label style={{ fontWeight: 500 }}>Carry Forward:</label>
                    <SwitchField
                      checked={leaveData.carryFlag === true}
                      onChange={(checked) => handleChange("carryFlag", checked)}
                      style={{ marginLeft: 10 }}
                    />
                    <span style={{ marginLeft: 10 }}>{leaveData.carryFlag ? "Yes" : "No"}</span>
                  </div>

                  {leaveData.carryFlag && (
                    <div style={{ marginTop: 16 }}>
                      <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                        Carry Forward Leaves:<span style={{ color: "red", marginLeft: 4 }}>*</span>
                      </label>
                      <InputField
                        value={leaveData.CarryforwardLeaves}
                        type="number"
                        name="CarryforwardLeaves"
                        onChange={(e) => handleChange("CarryforwardLeaves", e.target.value)}
                        className="form-control"
                      />
                    </div>
                  )}
                </form>
              </Modal>

              {leavesData.length === 0 ? (
                <div style={{ textAlign: "center", marginTop: 120 }}>
                  <Typography.Text type="secondary" style={{ fontSize: 16 }}>
                    No leave settings available. Please click "Add Leave" to create one.
                  </Typography.Text>
                </div>
              ) : (
                Object.keys(leavesByYear)
                  .sort((a, b) => Number(b) - Number(a))
                  .map((year) => (
                    <div key={year} style={{ marginTop: 30 }}>
                      <Title level={5}>Year: {year}</Title>
                      <Table
                        dataSource={leavesByYear[year]}
                        rowKey={(record) => `${record.department}-${record.year}`}
                        columns={tableColumns}
                        pagination={false}
                        size="middle"
                        onRow={(record) => ({
                          onClick: () => {
                            const key = `${record.department}-${record.year}`;
                            setExpandedRowKeys((prev) =>
                              prev.includes(key)
                                ? prev.filter((k) => k !== key)
                                : [...prev, key]
                            );
                          },
                          style: { cursor: "pointer" },
                        })}
                        expandable={{
                          expandedRowKeys,
                          onExpand: (expanded, record) => {
                            const key = `${record.department}-${record.year}`;
                            setExpandedRowKeys((prev) =>
                              expanded
                                ? [...prev, key]
                                : prev.filter((k) => k !== key)
                            );
                          },
                          expandedRowRender: (record) => (
                            <QuarterlyBreakdownTable record={record} />
                          ),
                          rowExpandable: () => true,
                        }}
                      />
                    </div>
                  ))
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveSettings;